import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { VarDirective } from '../../../core-components/var/var.directive';
import { UserModel } from '../../models/user.model';
import { authActions } from '../../store/auth.actions';
import { authFeature } from '../../store/auth.state';

@Component({
    selector: 'phx-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [VarDirective, FormsModule, ReactiveFormsModule, AsyncPipe]
})
export class LoginComponent implements OnInit {
    loginFormGroup: UntypedFormGroup;
    usernameControl: UntypedFormControl;
    passwordControl: UntypedFormControl;
    impersonateAsControl: UntypedFormControl;

    user$: Observable<UserModel>;

    constructor(
        private store: Store,
        private activatedRoute: ActivatedRoute,
        private titleService: Title
    ) {}

    ngOnInit(): void {
        this.user$ = this.store.select(authFeature.selectUser);

        // setup login form
        this.usernameControl = new UntypedFormControl(null, [Validators.required]);
        this.passwordControl = new UntypedFormControl(null, [Validators.required]);
        this.impersonateAsControl = new UntypedFormControl(null);
        this.loginFormGroup = new UntypedFormGroup({
            username: this.usernameControl,
            password: this.passwordControl,
            impersonateAs: this.impersonateAsControl
        });

        this.titleService.setTitle(this.activatedRoute.snapshot.data?.['title']);
    }

    login() {
        this.store.dispatch(
            authActions.login({
                credentials: { username: this.usernameControl.value, password: this.passwordControl.value },
                impersonateAs: this.impersonateAsControl.value
            })
        );
    }

    logout() {
        this.store.dispatch(authActions.logout({}));
    }
}
